<template>
  <div>
    <div
      :class="isSidebarMinimized ? 's-minimized' : ''"
      class="sidebar-video-recording"
    >
      <i
        class="c-sidebar-nav-icon cil-video"
      />
      
      <div class="video-screen-recording-container items-center cursor-pointer">
        <b-button-group size="sm">
          <b-button
            v-b-tooltip.hover
            variant="outline-info cursor-pointer"
            title="Start video recording"
            @click.stop="sendMessage(START_RECORDING)"
          >
            <b-icon icon="camera-reels" />
          </b-button>
          <b-button
            v-b-tooltip.hover
            variant="outline-info cursor-pointer"
            title="Start video and screen recording"
            @click="sendMessage(START_VIDEO_AND_SCREEN_RECORDING)"
          >
            <b-icon icon="fullscreen" />
          </b-button>
          <b-button
            v-b-tooltip.hover
            variant="outline-info cursor-pointer"
            title="Start screen recording with audio only"
            @click="sendMessage(START_SCREEN_RECORDING)"
          >
            <b-icon icon="display" />
          </b-button>
          <b-button
            v-if="recording"
            v-b-tooltip.hover
            variant="outline-danger cursor-pointer"
            title="Stop recording"
            @click="sendMessage(STOP_RECORDING, false)"
          >
            <b-icon icon="stop-circle" />
          </b-button>
          <b-button
            v-if="recordingUploading"
            v-b-tooltip.hover
            variant="outline-info cursor-pointer"
            title="Uploading..."
          >
            <b-spinner
              small
              label="Spinning"
            />
          </b-button>
        </b-button-group>
        <b-button
          v-b-tooltip.hover
          variant="outline-info cursor-pointer ml-1"
          title="Show recordings"
          size="sm"
          @click="handleShowRecordingsBtn"
        >
          <b-spinner
            v-if="recordingsLoading"
            small
            label="Spinning"
          />
          <b-icon
            v-else
            icon="folder"
          />
        </b-button>
      </div>
    </div>
    <RecordingsListModal
      :modal-id="globalRecordingModalId"
      :recordings="recordings"
      :current-page="currentPage"
      :total="recordingsCount"
      @pageChanged="handlePageChanged"
      @delete="handleDeletedBtn"
      @close="$bvModal.hide(globalRecordingModalId)"
      @changeName="handleChangeName"
    />
  </div>
</template>
<script>
/* eslint vue/enforce-style-attribute: 0 */
import {
  VIDEO_BROADCAST_CHANNEL,
  VIDEO_BROADCAST_EVENTS
} from "@frontend/components/modules/video-screen-recording/constants.js";
import RecordingsListModal from "@frontend/components/modules/video-screen-recording/recordings-list-modal.vue";
import FileBrowser from "@frontend/services/api/file-browser";
export default {
  name: 'GlobalVideoScreenRecording',
  components: {RecordingsListModal},
 
  data() {
    return {
      isSidebarMinimized: false,
      broadcastChannel: null,
      screenRecordingFolderId: null,
      recording: false,
      recordingUploading: false,
      recordingsLoading: false,
      recordings: [],
      recordingsCount: null,
      currentPage: 1,
      globalRecordingModalId: 'globalRecordingModal',
      popupOpened: false,
    };
  },
  computed: {
    START_VIDEO_AND_SCREEN_RECORDING() {
      return VIDEO_BROADCAST_EVENTS.START_VIDEO_AND_SCREEN_RECORDING;
    },
    START_SCREEN_RECORDING() {
      return VIDEO_BROADCAST_EVENTS.START_SCREEN_RECORDING
    },
    START_RECORDING() {
      return VIDEO_BROADCAST_EVENTS.START_RECORDING
    },
    STOP_RECORDING() {
      return VIDEO_BROADCAST_EVENTS.STOP_RECORDING
    },
    POPUP_STATUS_RESPONSE() {
      return VIDEO_BROADCAST_EVENTS.POPUP_STATUS_RESPONSE;
    },
    OPEN_RECORDINGS_MODAL() {
      return VIDEO_BROADCAST_EVENTS.OPEN_RECORDINGS_MODAL;
    }
  },

  async mounted() {
   
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    const update = () => {
      this.isSidebarMinimized = sidebar.classList.contains('c-sidebar-minimized');
    };

    update();

    const observer = new MutationObserver(update);
    observer.observe(sidebar, {
      attributes: true,
      attributeFilter: ['class']
    });

    this._observer = observer;
    this.broadcastChannel = new BroadcastChannel(VIDEO_BROADCAST_CHANNEL);
    this.broadcastChannel.onmessage = (event) => {
      const {recording, recordingUploading,recordingsLoading} = event.data;
      switch (event.data.type) {
        case VIDEO_BROADCAST_EVENTS.POPUP_STATUS_RESPONSE : 
          this.popupOpened = true;
          this.recording = recording;
          this.recordingUploading = recordingUploading
          this.recordingsLoading = recordingsLoading;
          break;
          
        case VIDEO_BROADCAST_EVENTS.OPEN_RECORDINGS_MODAL: 
          this.handleShowRecordingsBtn();
          break;
      }
    }
    // for recordings popup
    const { data: folder } = await FileBrowser.getFolderByName('Screen recording');
    this.screenRecordingFolderId = folder[0]?.id;
    // request status from the popup
    this.sendMessage(VIDEO_BROADCAST_EVENTS.POPUP_STATUS, false)
  },
  beforeDestroy() {
    this._observer?.disconnect();
  },
  methods: {
    openVideoRecording(message) {
      const width = 400;
      const height = 400;
      const top = window.innerHeight / 2 - height / 2;
      const left = window.innerWidth / 2 - width / 2;

      const features = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=no,status=no,toolbar=no,menubar=no,location=no`;
      
       window.open(
          '/recording#' + message,
          `RecordingWindow`,
          features
       )
     
    }, 
    sendMessage(message, openPopup = true) {
      // Send a message to the popup
      if (openPopup) {
        this.openVideoRecording(message);
        if (!this.popupOpened) {
          return;
        }
      }
      
      this.broadcastChannel.postMessage({
        type: message,
        payload: {
          message: message
        }
      });
    },
    
    async handleShowRecordingsBtn() {
      this.recordingsLoading = true;

      await this.fetchRecordings();

      this.$bvModal.show(this.globalRecordingModalId);

      this.recordingsLoading = false;
    },
    async fetchRecordings(page = 1) {
      try {
        if (!this.screenRecordingFolderId) return;

        const { data } = await FileBrowser.getFolderContent(this.screenRecordingFolderId, page);

        this.recordings = data.items.filter(item => item.type !== 'folder');
        this.recordingsCount = data.totalCount;

      } catch (err) {
        console.log(err);
      }
    },

    async handlePageChanged(page) {
      await this.fetchRecordings(page);
    },

    async handleDeletedBtn(id) {
      try {
        await FileBrowser.deleteFolderFile(id);

        this.recordings = this.recordings.filter(rec => rec.id !== id);

        toastr.success('Video deleted');
      } catch (err) {
        console.log(err);
      }
    },
    async handleChangeName(data) {
      try {
        await FileBrowser.updateFolderFile(data);

        this.recordings = this.recordings.map(item => {
          if (item.id === data.id) {
            return {
              ...item,
              name: data.name
            }
          }

          return item;
        })
      } catch (e) {
        console.log(e);
        toastr.error('Failed to rename video');
      }
    }
   
  }
}
</script>
<style  lang="scss">
  .sidebar-video-recording {
    position:relative; 
    display:flex;
    transition: opacity 0.3s ease-in-out;
    padding: 15px 15px 15px 17px;
    align-items:center;
    
    i {
      display:none;
        
      transition: opacity 0.3s ease-in-out;
    }
  }
  .sidebar-video-recording.s-minimized {
    margin-bottom: 50px !important;
    i {
      display:block;
      cursor:pointer;
     
    }
    i:hover {
      color:#fec350 !important;
    }
    .video-screen-recording-container {
      display: none !important;
      transition: opacity 0.3s ease-in-out;
      background: #007964;
    }
    
  }
  .sidebar-video-recording.s-minimized:hover {
    .video-screen-recording-container {
      display: flex !important;
      position: absolute;
      top: 0;
      left: 100%;
      width: 200px;
      height: 51px;
      padding: 9px 15px;
     
    }
  }
  .sidebar-video-recording.s-minimized:hover > .video-screen-recording-container .video-preview {
    margin-top: -200px !important;
    z-index: -1;
  }

  
  .video-screen-recording-container {
     display: flex;
     flex-wrap: nowrap;
     min-width: 200px;
     overflow: hidden;
     width: 100%;
    .btn-outline-info {
      color: #ffffff !important;
      border-color: rgba(255,255,255,0.7) !important;
      opacity: 0.8 !important;
    }
  }
  .video-screen-recording-container > .video-preview {
    padding-top:100px !important;
  }
  @media (max-width: 768px) {
    .video-screen-recording-container {
      display: flex !important;
     
    }
    .sidebar-video-recording i {
      display:block !important;
    }
    .sidebar-video-recording {
      padding-left:20px;
    }
  }
</style>
